import { IAdminUser } from '../../share-types'
import { UserInfoAction } from './action'
import { SET_USER_INFO, CLEAR_USER_INFO } from './constants'
import update from 'immutability-helper'

const initialState: IAdminUser | null = null
function userInfoReducer(state = initialState, action: UserInfoAction) {
  switch (action.type) {
    case SET_USER_INFO:
      return update(state, { $set: action.payload })
    case CLEAR_USER_INFO:
      return Object.assign({}, initialState)
    default:
      return state
  }
}

export default userInfoReducer
